/**
 * Product page: scroll cues for the vertical thumbnail column.
 *
 * The column shows 6 thumbnails and scrolls the rest (CSS in
 * poplife-tokens.css.liquid). This adds a fade + chevron at whichever
 * end still has hidden images, and lets the chevron scroll one step.
 * State classes go on .thumbnail-slider: pl-thumbs--more-below / --more-above.
 */
(function () {
  function init(slider) {
    var list = slider.querySelector('.thumbnail-list');
    if (!list || slider.dataset.plThumbs) return;
    slider.dataset.plThumbs = '1';

    function makeBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pl-thumbs__cue pl-thumbs__cue--' + dir;
      b.setAttribute('aria-label', dir === 'down' ? 'Show more images' : 'Show previous images');
      b.innerHTML =
        '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3 6l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function () {
        var step = list.clientHeight * 0.6;
        list.scrollBy({ top: dir === 'down' ? step : -step, behavior: 'smooth' });
      });
      slider.appendChild(b);
    }
    makeBtn('up');
    makeBtn('down');

    function update() {
      var max = list.scrollHeight - list.clientHeight;
      slider.classList.toggle('pl-thumbs--more-below', max > 2 && list.scrollTop < max - 2);
      slider.classList.toggle('pl-thumbs--more-above', max > 2 && list.scrollTop > 2);
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(list);
    window.addEventListener('load', update);
    update();
  }

  function run() {
    document.querySelectorAll('media-gallery .thumbnail-slider').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
